import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useUpdateUnderwriterMutation } from 'API/order/OrderApi';
import React, { useMemo, useState } from 'react';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { Button, Grid, NavigationItem, Notification, Select, Spinner } from 'ui-toolkit';
import { Card } from 'ui-toolkit/components/Card';
import { assertDefined } from 'utilities/Assertions';
import { eUnderwriter } from '../../ui-toolkit/enums/eUnderwriter';
import { ePartyPurpose } from '../../ui-toolkit/enums/ePartyPurpose';
import { assertIsEntity } from '../../ui-toolkit/orders/interfaces/IParty';

export const OrderAdministrationContainer: React.FC = () => {
  const options = useMemo(() => Object.keys(eUnderwriter).map((t) => ({ label: t, value: t })), []);
  const { data } = useSelectCurrentOrder();
  const id = data.transaction.id;
  assertDefined(id);
  const underwriter = data.parties.find((t) => t.purpose === ePartyPurpose.underwriter);
  assertDefined(underwriter);
  assertIsEntity(underwriter);

  const currentOption = options.find((t) => t.value === underwriter.entity_value);
  const [selectedOption, setSelectedOption] = useState(currentOption);

  const [putUpdateWriter, { isLoading, isSuccess }] = useUpdateUnderwriterMutation();

  const onClick = () => {
    putUpdateWriter({ id, underwriter: selectedOption?.value as eUnderwriter });
  };

  return (
    <Card title={<>Change Underwriter</>}>
      <Grid>
        {selectedOption?.value === eUnderwriter.AmericanDigital && (
          <Notification type={'warning'}>
            After changing the underwriter, if you changed it to ADTIC, you MUST
            <ol>
              <li>
                Go to{' '}
                <NavigationItem
                  href={`https://rabbitmq.spruce.co/#/queues`}
                  target={`_blank`}
                  text={`Rabbit MQ`}
                  isInline
                />
              </li>
              <li>
                Add a message to the queue as outlined{' '}
                <NavigationItem
                  href={`https://spruceco.atlassian.net/wiki/spaces/HD/pages/800489533/Change+an+Underwriter#Send-Order-Created-Message-In-Rabbit-MQ`}
                  target={`_blank`}
                  text={`in confluence`}
                  isInline
                />
              </li>
            </ol>
          </Notification>
        )}
        <Grid templateColumns={`480px 240px 120px`}>
          <Select
            options={options}
            value={selectedOption}
            onChange={setSelectedOption}
            label={`Select the new underwriter`}
          />
          <Button intent={'primary'} onClick={onClick}>
            Submit
          </Button>
          {isLoading && <Spinner />}
          {isSuccess && <FontAwesomeIcon icon={faCheckCircle} />}
        </Grid>
      </Grid>
    </Card>
  );
};
